import React from 'react';

export default function SpinboardMark({ size = 28 }) {
  const cx = size / 2, cy = size / 2, r = size * 0.42;
  const ringR = r, strokeW = size * 0.09;
  const dotR = size * 0.09;
  const start = { x: cx + r * Math.cos(Math.PI * 270 / 180), y: cy + r * Math.sin(Math.PI * 270 / 180) };
  const end   = { x: cx + r * Math.cos(Math.PI * 150 / 180), y: cy + r * Math.sin(Math.PI * 150 / 180) };
  const cellW = size * 0.18, cellH = size * 0.15, gap = size * 0.05;
  const gridW = 3 * cellW + 2 * gap, gridH = 2 * cellH + gap;
  const gx = cx - gridW / 2, gy = cy - gridH / 2;
  const cells = [
    [0,0,1], [1,0,0.5], [2,0,0.2],
    [0,1,0.5], [1,1,1], [2,1,'orange'],
  ];
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none">
      <circle cx={cx} cy={cy} r={ringR} stroke="#ffffff" strokeWidth={strokeW * 0.7} opacity={0.15}/>
      <path
        d={`M ${start.x.toFixed(2)} ${start.y.toFixed(2)} A ${r} ${r} 0 1 1 ${end.x.toFixed(2)} ${end.y.toFixed(2)}`}
        stroke="#ffffff" strokeWidth={strokeW} strokeLinecap="round"/>
      <circle cx={start.x} cy={start.y} r={dotR} fill="#F4622A"/>
      {cells.map(([col, row, op]) => (
        <rect
          key={`${col}-${row}`}
          x={gx + col * (cellW + gap)}
          y={gy + row * (cellH + gap)}
          width={cellW} height={cellH} rx={size * 0.03}
          fill={op === 'orange' ? '#F4622A' : '#ffffff'}
          opacity={op === 'orange' ? 1 : op}
        />
      ))}
    </svg>
  );
}